export const initializeUnitConversion = () => {
  const container = document.getElementById("chamfr-units-switch");

  if (!container) {
    return;
  }

  const switches = [
    { system: "imperial", label: "in" },
    { system: "metric", label: "mm" },
  ].map((el) => {
    const single = document.createElement("a");
    single.innerHTML = el.label;
    single.href = "#";
    if (el.system === selectedUnits()) {
      single.className = "active";
    }
    single.addEventListener("click", (e) => {
      e.preventDefault();
      localStorage.setItem("chamfr-units", el.system);
      window.location.reload();
    });
    const switchContainer = document.createElement("span");
    switchContainer.appendChild(single);
    switchContainer.className = el.system;
    return switchContainer;
  });

  container.appendChild(switches[0]);
  container.appendChild(switches[1]);

  const tooltip = document.createElement("span");
  tooltip.innerHTML = "All filters will be reset upon switching";
  tooltip.className = "tt";
  container.appendChild(tooltip);
};

export const selectedUnits = () => {
  return localStorage.getItem("chamfr-units") ?? "imperial";
};

const applyLabelUnits = (label) => {
  if ("metric" === selectedUnits()) {
    label = replaceArray(
      label,
      [/(\W)in(\W)/, /(\W)ft(\W)/],
      ["$1mm$2", "$1cm$2"]
    );
  } else {
    label = replaceArray(
      label,
      [/(\W)mm(\W)/, /(\W)cm(\W)/],
      ["$1in$2", "$1ft$2"]
    );
  }
  return label;
};

export const applyAttributeUnits = (attribute, unitsFrom) => {
  const removedAllSuffix = attribute.replace(/(-(?:in|ft|mm|cm))+$/, "");
  let newSuffix = "";
  if ("metric" === selectedUnits()) {
    if ("in" === unitsFrom) {
      newSuffix = "-mm";
    } else if ("ft" === unitsFrom) {
      newSuffix = "-cm";
    }
  } else if ("imperial" === selectedUnits()) {
    if ("mm" === unitsFrom) {
      newSuffix = "-in";
    } else if ("cm" === unitsFrom) {
      newSuffix = "-ft";
    }
  }
  if (newSuffix) {
    return removedAllSuffix + newSuffix;
  }
  return attribute;
};

export const replaceArray = (replaceString, find, replace) => {
  for (let i = 0; i < find.length; i++) {
    replaceString = replaceString.replace(new RegExp(find[i], "g"), replace[i]);
  }
  return replaceString;
};

export const convertFacet = (facet) => {
  if ("undefined" === typeof facet.originalAttribute) {
    facet.originalAttribute = facet.attribute;
  }

  // If facet is not convertible, return as is.
  if (!facet.units) {
    return facet;
  }

  facet.label = applyLabelUnits(facet.label);
  if (facet.label_column) {
    facet.label_column = applyLabelUnits(facet.label_column);
  }

  facet.attribute = applyAttributeUnits(facet.attribute, facet.units);

  return facet;
};
